module.exports = __webpack_public_path__ + "static/media/review_icon.bac912ca.png";